import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });
export const SHIFTS = ["Morning", "Afternoon", "Night"];

export const todayStr = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

export const completion = (items) =>
  items.length ? Math.round((items.filter((i) => i.done).length * 100) / items.length) : 0;

export const exportUrl = (type, params) => {
  const q = new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString();
  return `${API}/export/${type}${q ? `?${q}` : ""}`;
};

export const errMsg = (e) => e?.response?.data?.detail || "Something went wrong";
